export const googleAnalyticsId = "G-PWJN1DH7GM";
